import { render, staticRenderFns } from "./EdicionRegistroAdmin.vue?vue&type=template&id=7b1c9106&"
import script from "./EdicionRegistroAdmin.vue?vue&type=script&lang=js&"
export * from "./EdicionRegistroAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports